import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: (failureCount,err) => {
                if(err?.status === 401 || err?.status === 403) return false;
                return failureCount < 2;
            }
        },
        mutations: {
            retry: 0
        }
    }
})
